import { render, staticRenderFns } from "./Gateway485Manage.vue?vue&type=template&id=c9cfe5a6&"
import script from "./Gateway485Manage.vue?vue&type=script&lang=js&"
export * from "./Gateway485Manage.vue?vue&type=script&lang=js&"
import style0 from "./Gateway485Manage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports